export const createEditFacebookLeadPageForm = id => "marketplaceEditFacebookLeadPageForm" + id;
export const createDeleteFacebookLeadPageForm = id => "marketplaceDeleteFacebookLeadPageForm" + id;
export const createRefreshFacebookLeadPageForm = id => "marketplaceRefreshFacebookLeadPageForm" + id;